<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm"></app-dati-generali-fascicolo-common>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" />

  <div class="row">
    <div comboModInput class="col-sm-4" [labelInput]="'Tipo di indagine preliminare'"
      formControlName="tipoIndaginePreliminare" [labelOption]="'descrizione'" [optionsCombo]="tipiIndaginePreliminare"
      [objectReference]="request.fascicolo.tipoIndaginePreliminare"
      [ngModel]="request.fascicolo.tipoIndaginePreliminare" [control]="request.fascicolo.tipoIndaginePreliminare"
      (onReturn)="request.fascicolo.tipoIndaginePreliminare = $event"></div>
  </div>

  <div class="row container_fieldset">
   <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Giudici</legend>
      <div textInput class="col-sm-4" [labelInput]="'Giudice indagini preliminari (G.I.P.)'"
        formControlName="giudiceIndaginiPreliminari" [(ngModel)]="request.fascicolo.giudiceIndaginiPreliminari">
      </div>

      <div textInput class="col-sm-4" [labelInput]="'Giudice udienza preliminare (G.U.P.)'"
        formControlName="giudiceUdienzaPreliminare" [(ngModel)]="request.fascicolo.giudiceUdienzaPreliminare">
      </div>

      <div textInput class="col-sm-4" [labelInput]="'Pubblico Ministero (P.M.)'" formControlName="pubblicoMinistero"
        [(ngModel)]="request.fascicolo.pubblicoMinistero">
      </div>
    </fieldset>
   </div>
  </div>

  <div class="row container_fieldset">
   <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Incidente probatorio</legend>
      <div class="row" style="margin-left: 5px;margin-right: 5px;">
        <div checkBoxRadio class="col-sm-4" [labelInput]="'Incidente probatorio'" idInput="incidenteProbatorio"
          formControlName="incidenteProbatorio" [objectReference]="request.fascicolo.incidenteProbatorio"
          [(ngModel)]="request.fascicolo.incidenteProbatorio" (onReturn)="request.fascicolo.incidenteProbatorio = $event">
        </div>

        <div checkBoxRadio class="col-sm-4" [labelInput]="'Richiesta archiviazione al G.I.P'" idInput="richiestaArchiviazione"
          formControlName="richiestaArchiviazione"
          (change)="request.fascicolo.dataRichiestaArchiviazione = null"
          [objectReference]="request.fascicolo.richiestaArchiviazione"
          [(ngModel)]="request.fascicolo.richiestaArchiviazione"
          (onReturn)="request.fascicolo.richiestaArchiviazione = $event">
        </div>

        <div datePickerInput class="col-sm-4" [labelInput]="'Data richiesta archiviazione'"
          formControlName="dataRichiestaArchiviazione" [(ngModel)]="request.fascicolo.dataRichiestaArchiviazione"
          [submitPending]="!request.fascicolo.richiestaArchiviazione"
          (onReturn)="request.fascicolo.richiestaArchiviazione = $event">
        </div>
      </div>
      <div class="row" style="margin-left: 5px;">
        <div checkBoxRadio class="col-sm-4" [labelInput]="'Ulteriori indagini PM'" idInput="rimandoAlPM"
          formControlName="rimandoAlPM" [objectReference]="request.fascicolo.rimandoAlPM"
          [(ngModel)]="request.fascicolo.rimandoAlPM" (onReturn)="request.fascicolo.rimandoAlPM = $event">
        </div>

        <div checkBoxRadio class="col-sm-4" [labelInput]="'Richiesta rinvio a giudizio'" idInput="richiestaRinvioAGiudizio"
          formControlName="richiestaRinvioAGiudizio" [objectReference]="request.fascicolo.richiestaRinvioAGiudizio"
          [(ngModel)]="request.fascicolo.richiestaRinvioAGiudizio"
          (onReturn)="request.fascicolo.richiestaRinvioAGiudizio = $event">
        </div>

        <div checkBoxRadio class="col-sm-4" [labelInput]="'Richiesta oblazione'" idInput="richiestaOblazione"
          formControlName="richiestaOblazione" [objectReference]="request.fascicolo.richiestaOblazione"
          [(ngModel)]="request.fascicolo.richiestaOblazione"
          (onReturn)="request.fascicolo.richiestaOblazione = $event">
        </div>
      </div>
      <div class="row" style="margin-left: 5px;margin-right: 5px;">
        <div checkBoxRadio class="col-sm-6" [labelInput]="'Opposizione archiviazione'"
            formControlName="opposizioneArchiviazione" (change)="request.fascicolo.dataOpposizioneArchiviazione = null"
            [objectReference]="request.fascicolo.opposizioneArchiviazione"
            [(ngModel)]="request.fascicolo.opposizioneArchiviazione"
            (onReturn)="request.fascicolo.opposizioneArchiviazione = $event">
        </div>
        <div datePickerInput class="col-sm-6" [labelInput]="'Data opposizione archiviazione'"
          [submitPending]="!request.fascicolo.opposizioneArchiviazione"
          [dataDal]="request.fascicolo.dataRichiestaArchiviazione" formControlName="dataOpposizioneArchiviazione"
          [(ngModel)]="request.fascicolo.dataOpposizioneArchiviazione">
        </div>
      </div>
    </fieldset>
   </div>
  </div>

  <!-- <div class="row container_fieldset">
   <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Prove</legend>
      <div checkBoxRadio class="col-sm-3" [labelInput]="'Sufficienza prove'" idInput="sufficienzaProve"
        formControlName="sufficienzaProve" (change)="request.fascicolo.prove = null"
        [objectReference]="request.fascicolo.sufficienzaProve" [(ngModel)]="request.fascicolo.sufficienzaProve"
        (onReturn)="request.fascicolo.sufficienzaProve = $event"></div>

      <div textAreaInput class="col-sm-9" [submitPending]="!request.fascicolo.sufficienzaProve" [labelInput]="'Prove'"
        formControlName="prove" [(ngModel)]="request.fascicolo.prove"></div>

    </fieldset>
   </div>
  </div> -->

  <div class="row container_fieldset">
   <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Misure cautelari</legend>
      <div checkBoxRadio class="col-sm-3" [labelInput]="'Misure cautelari'" idInput="misureCautelari"
        formControlName="misureCautelari" (change)="request.fascicolo.misuraAdottata = null"
        [objectReference]="request.fascicolo.misureCautelari" [(ngModel)]="request.fascicolo.misureCautelari"
        (onReturn)="request.fascicolo.misureCautelari = $event"></div>

      <div textAreaInput class="col-sm-9" [submitPending]="!request.fascicolo.misureCautelari"
        [labelInput]="'Misura adottata'" formControlName="misuraAdottata"
        [(ngModel)]="request.fascicolo.misuraAdottata"></div>

    </fieldset>
   </div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Note'" formControlName="note"
      [(ngModel)]="request.fascicolo.note"></div>
  </div>
  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="col-md-12 mandatory">
      <em>* Campi obbligatori</em>
    </p>
  </div>
  <!-- <div *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi"
    class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)"></p>
    </div>
  </div> -->

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="resetForm.emit()">Reset</button>
    </p>
    <!--<p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
      [labelButton]="'Salva'" [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
                        (!request.fascicolo.flagFondoRischi && !inserimento && !wizard ? !request.fascicolo.dataVariazioneFondoRischi : false) ||
                        !datiGeneraliForm.valid"></p>  -->
    <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'"
      [disabled]="!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>

</form>
